import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG
} from "ngx-perfect-scrollbar";

import { CoreCommonModule } from "@core/common.module";
import { CoreTouchspinModule } from "@core/components/core-touchspin/core-touchspin.module";

import { NavbarComponent } from "app/layout/components/navbar/navbar.component";
import { NavbarBookmarkComponent } from "app/layout/components/navbar/navbar-bookmark/navbar-bookmark.component";
import { NavbarSearchComponent } from "app/layout/components/navbar/navbar-search/navbar-search.component";
import { NavbarNotificationComponent } from "app/layout/components/navbar/navbar-notification/navbar-notification.component";
import { NavbarShortcutsComponent } from "app/layout/components/navbar/navbar-shortcuts/navbar-shortcuts.component";
import { StatsInfoModule } from "app/layout/components/navbar/stats-info/stats-info.module";
import { LanguageSwitcherModule } from "app/components/language-switcher/language-switcher.module";
import { coreMenuLucideIcons } from "app/utils/config/menu-icons";
import {
  NavbarCenterPortalDirective,
  NavbarLeftPortalDirective,
  NavbarRightPortalDirective
} from "app/layout/components/navbar/directives/navbar-portal.directive";

import {
  LucideAngularModule,
  Minimize2,
  Maximize2,
  User,
  Power,
  LayoutGrid,
  Calendar,
  FileText,
  Users,
  Settings,
  Plus,
  Tv,
  X,
  Cctv,
} from "lucide-angular";

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};

@NgModule({
  declarations: [
    NavbarComponent,
    NavbarSearchComponent,
    NavbarBookmarkComponent,
    NavbarNotificationComponent,
    NavbarShortcutsComponent,
    NavbarCenterPortalDirective,
    NavbarLeftPortalDirective,
    NavbarRightPortalDirective,
  ],
  imports: [
    RouterModule,
    NgbModule,
    CoreCommonModule,
    PerfectScrollbarModule,
    CoreTouchspinModule,
    StatsInfoModule,
    LanguageSwitcherModule,
    LucideAngularModule.pick({
      ...coreMenuLucideIcons,
      Minimize2,
      Maximize2,
      User,
      Power,
      LayoutGrid,
      Calendar,
      FileText,
      Users,
      Settings,
      Plus,
      Tv,
      X,
      Cctv,
    }),
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  exports: [
    NavbarComponent,
    NavbarShortcutsComponent,
    NavbarNotificationComponent,
    NavbarCenterPortalDirective,
    NavbarLeftPortalDirective,
    NavbarRightPortalDirective,
  ]
})
export class NavbarModule {}
